import { selectComponentState } from 'projectRedux/store';
import { valveConnectorGridAdapter } from '../adapters/valveConnectorGridAdapter';

export const {
  selectAll: selectAllValveConnectorGrids,
  selectById: selectValveConnectorGridById,
  selectEntities: selectValveConnectorGridEntities,
} = valveConnectorGridAdapter.getSelectors((state) => selectComponentState(state).valveConnectorGrids);
